import Report from '@/classes/Report';
import store from '@/store/store';
import moment from 'moment';
class ReportCollection {
    reports = [];
    constructor() {
        //this.reports = this.convertToReportObjectsFromJson(reports);
        //this.update();
    }
    importReportObjectsFromJson(reportsJson) {
        reportsJson.forEach((report) => {
            const tempReport = new Report(report);
            this.reports.push(tempReport); //push to the reports array.
        });
    }
    //returns all the reports for a specific date
    getReportsForDate(date) {
        return this.reports.filter((report) => {
            return (moment(report.date).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD"));
        });
    }
    getReportsForTariffDate(date, tariffId) {
        return this.reports.filter((report) => {
            return (moment(report.date).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD") && report.tariffId === tariffId);
        });
    }
    getReportsForEmployeeMonth(userId) {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        return this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.userId === userId));
        });
    }
    /*public getReportsForEmployeeCustomerMonth(userId: string, customerName: string){
        const start = (window as any).dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = (window as any).dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        return this.reports.filter((report: Report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.userId === userId && report.customerName === customerName));
        });
    }*/
    getNonWorkingReportsForEmployeeMonth(userId) {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const filteredReports = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.userId === userId && (report.absence === 'Vacation' || report.absence === 'LongTerm')));
        });
        const rows = [];
        let row = [];
        filteredReports.forEach((report, index) => {
            if (index === 0) {
                row.push(report);
            }
            else if (index > 0) {
                const previousReport = filteredReports[index - 1];
                const nextDayFromPrevious = window.dateHandler.formatDateNoTime(window.dateHandler.addDays(previousReport.date, 1));
                if (nextDayFromPrevious === window.dateHandler.formatDateNoTime(report.date) && previousReport.tariffId === report.tariffId) {
                    row.push(report);
                }
                else {
                    rows.push(row);
                    row = [];
                    row.push(report);
                }
            }
            if (index === filteredReports.length - 1) {
                rows.push(row);
            }
        });
        return rows;
    }
    getNonWorkingReportsMonth() {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const filteredReports = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && ( /*report.absence === 'Vacation' ||*/report.absence === 'LongTerm')));
        });
        const rows = [];
        let row = [];
        //console.log(filteredReports);
        filteredReports.forEach((report, index) => {
            if (index === 0) {
                row.push(report);
            }
            else if (index > 0) {
                const previousReport = filteredReports[index - 1];
                const nextDayFromPrevious = window.dateHandler.formatDateNoTime(window.dateHandler.addDays(previousReport.date, 1));
                if (nextDayFromPrevious === window.dateHandler.formatDateNoTime(report.date) && previousReport.tariffId === report.tariffId) {
                    row.push(report);
                }
                else {
                    rows.push(row);
                    row = [];
                    row.push(report);
                }
            }
            if (index === filteredReports.length - 1) {
                rows.push(row);
            }
        });
        return rows;
    }
    getVacationReportsMonth() {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const filteredReports = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.absence === 'Vacation'));
        });
        const rows = [];
        let row = [];
        //console.log(filteredReports);
        filteredReports.forEach((report, index) => {
            if (index === 0) {
                row.push(report);
            }
            else if (index > 0) {
                const previousReport = filteredReports[index - 1];
                const nextDayFromPrevious = window.dateHandler.formatDateNoTime(window.dateHandler.addDays(previousReport.date, 1));
                if (nextDayFromPrevious === window.dateHandler.formatDateNoTime(report.date) && previousReport.tariffId === report.tariffId) {
                    row.push(report);
                }
                else {
                    rows.push(row);
                    row = [];
                    row.push(report);
                }
            }
            if (index === filteredReports.length - 1) {
                rows.push(row);
            }
        });
        return rows;
    }
    getReportsForTariff(tariffId) {
        return this.reports.filter((report) => {
            return (report.tariffId === tariffId);
        });
    }
    getReportsForTariffCurrentMonth(tariffId) {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        return this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")) && (report.tariffId === tariffId));
        });
    }
    getTariffsForDateRange(range) {
        const start = moment(range[0]).format("YYYY-MM-DD");
        const end = moment(range[range.length - 1]).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")));
        });
        const temp = [...new Set(filtered.map((x) => x.tariffId))];
        return temp;
    }
    getEmployeesForMonth() {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")));
        });
        const temp = [...new Set(filtered.map((x) => x.userId))];
        temp.sort((a, b) => (a > b) ? 1 : -1);
        return temp;
    }
    getCustomersForMonth() {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")));
        });
        const temp = [...new Set(filtered.map((x) => x.customerName))];
        temp.sort((a, b) => (a > b) ? 1 : -1);
        return temp;
    }
    getTariffIdsForMonth() {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")));
        });
        const temp = [...new Set(filtered.map((x) => x.tariffId))];
        temp.sort((a, b) => (a > b) ? 1 : -1);
        return temp;
    }
    getTariffIdsForUserMonth(userId) {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.userId === userId));
        });
        const temp = [...new Set(filtered.map((x) => x.tariffId))];
        temp.sort((a, b) => (a > b) ? 1 : -1);
        return temp;
    }
    /*****************************************************/
    /*                   CUSTOMER HOURS                  */
    /*****************************************************/
    flattenReportsForCustomerMonth(_employeeCollectionAdminInput) {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const filteredReports = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")));
        });
    }
    getReportsForCustomerMonth(employeeCollectionAdminInput) {
        const start = window.dateHandler.getStartOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(store.getters.getSelectedDate).format("YYYY-MM-DD");
        const filteredReports = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")));
        });
        //customer -> tariff --> user --> Reports
        let users = [];
        let tariffs = [];
        const customers = [];
        let customerValues = [];
        const customerNames = [...new Set(filteredReports.map((x) => x.customerName))];
        customerNames.forEach((customerNameInternal) => {
            customerValues = [];
            let customerTotalHours = 0;
            let customerTotalBillable = 0;
            const customerFiltered = filteredReports.filter((report) => {
                return report.customerName === customerNameInternal;
            });
            const userIds = [...new Set(customerFiltered.map((x) => x.userId))];
            userIds.forEach((userIdString) => {
                users = [];
                const userFiltered = customerFiltered.filter((report) => {
                    return report.userId === userIdString;
                });
                const tariffIds = [...new Set(userFiltered.map((x) => x.tariffId))];
                tariffs = [];
                tariffIds.forEach((tariffIdString) => {
                    const tariffFilter = userFiltered.filter((report) => {
                        return report.tariffId === tariffIdString;
                    });
                    let totalHours = 0;
                    let userTariff = "";
                    let userBillable = false;
                    let tariffBillable = 0;
                    tariffFilter.forEach((report) => {
                        totalHours += report.hours;
                        customerTotalHours += report.hours;
                        if (report.billable === true) {
                            userBillable = true;
                            customerTotalBillable += report.hours;
                            tariffBillable += report.hours;
                        }
                        userTariff = report.tariffName;
                    });
                    const employeeNameInternal = employeeCollectionAdminInput.getEmployee(userIdString);
                    customerValues.push({ customerName: customerNameInternal, userId: userIdString, employeeName: employeeNameInternal, tariffId: tariffIdString, billable: userBillable, tariffName: userTariff, hours: totalHours });
                });
            });
            customers.push({ customerName: customerNameInternal, values: customerValues, hours: customerTotalHours, billable: customerTotalBillable });
        });
        return customers;
    }
    //returns the tariff ids for the current week
    getTariffIdsForWeek(specificWeek) {
        let start = '';
        let end = '';
        if (specificWeek !== undefined) { //if an input of a specific week is added this will get the dates for that week            
            start = window.dateHandler.getMondayFromWeekNumber(specificWeek);
            end = window.dateHandler.getSundayFromWeekNumber(specificWeek);
        }
        else {
            start = window.dateHandler.getMondayFromDate(store.getters.getSelectedDate);
            end = window.dateHandler.getSundayFromDate(store.getters.getSelectedDate);
        }
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")));
        });
        const temp = [...new Set(filtered.map((x) => x.tariffId))];
        temp.sort((a, b) => (a > b) ? 1 : -1);
        return temp;
    }
    //returns the reports for the current week
    getWeek(date) {
        if (date === undefined) {
            date = store.getters.getSelectedDate;
        }
        const dates = [];
        const monday = window.dateHandler.getMondayFromDate(date);
        for (let i = 0; i < 7; i++) {
            const currentDate = window.dateHandler.addDays(monday, i);
            dates.push({ date: currentDate, reports: this.getReportsForDate(currentDate) });
        }
        dates.forEach((internalDate) => {
            let totalHours = 0;
            internalDate.reports.forEach((dateReport) => {
                totalHours += Number(dateReport.hours);
            });
            internalDate.totalHours = totalHours;
            internalDate.reports.sort((a, b) => (a.tariffId > b.tariffId) ? 1 : -1);
        });
        return dates;
    }
    //returns the reports for a specific tariff for the current week
    getTariffWeek(tariffId, date) {
        if (date === undefined) {
            date = store.getters.getSelectedDate;
        }
        const dates = [];
        const monday = window.dateHandler.getMondayFromDate(date);
        for (let i = 0; i < 7; i++) {
            const currentDate = window.dateHandler.addDays(monday, i);
            dates.push({ date: currentDate, reports: this.getReportsForTariffDate(currentDate, tariffId) });
        }
        return dates;
    }
    //returns the sum of all reports in the week, if tariffId is present its specific to that tariff
    calculateWeekTime(tariffId) {
        const start = window.dateHandler.getMondayFromDate(store.getters.getSelectedDate);
        const end = window.dateHandler.getSundayFromDate(store.getters.getSelectedDate);
        const filtered = this.reports.filter((report) => {
            if (tariffId !== undefined) {
                return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.tariffId === tariffId));
            }
            else {
                return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")));
            }
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        return totalHours;
    }
    calculateMonthTime(date) {
        const selectedDate = date || store.getters.getSelectedDate;
        const start = window.dateHandler.getStartOfMonth(selectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(selectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")));
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        //this.monthHours = totalHours;
        return totalHours;
    }
    calculateMonthTimeUser(userId) {
        const selectedDate = store.getters.getSelectedDate;
        const start = window.dateHandler.getStartOfMonth(selectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(selectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")) && report.userId === userId);
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        //this.monthHours = totalHours;
        return totalHours;
    }
    calculateMonthTimeCustomer(customerName) {
        const selectedDate = store.getters.getSelectedDate;
        const start = window.dateHandler.getStartOfMonth(selectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(selectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD")) && report.customerName === customerName);
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        //this.monthHours = totalHours;
        return totalHours;
    }
    calculateMonthTimeForTariff(tariffId) {
        const selectedDate = store.getters.getSelectedDate;
        const start = window.dateHandler.getStartOfMonth(selectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(selectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.tariffId === tariffId));
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        return totalHours;
    }
    //returns the average amount of hours given the month
    getYearlyAverageForMonth(month) {
        const selectedDate = store.getters.getSelectedDate;
        const date = moment(selectedDate).set('month', month);
        const start = window.dateHandler.getStartOfYear(date).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(date).format("YYYY-MM-DD");
        console.log("workign with date:", start);
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.billable === true));
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        return totalHours / (month + 1);
    }
    //previous = number of months to go back
    calculateMonthBillable(previous, month) {
        let selectedDate = store.getters.getSelectedDate;
        if (previous !== undefined && previous !== null) {
            selectedDate = moment(store.getters.getSelectedDate).subtract(previous, 'months');
        }
        if (month !== undefined && month !== null) {
            selectedDate = moment(selectedDate).month(month);
        }
        //console.log(moment(selectedDate).format("YYYY-MM-DD") + " - inside calculatemonth")
        const start = window.dateHandler.getStartOfMonth(selectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(selectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.billable === true));
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        return totalHours;
    }
    //previous = number of months to go back
    calculateMonthStack(previous, month) {
        let selectedDate = store.getters.getSelectedDate;
        if (previous !== undefined && previous !== null) {
            selectedDate = moment(store.getters.getSelectedDate).subtract(previous, 'months');
        }
        if (month !== undefined && month !== null) {
            selectedDate = moment(selectedDate).month(month);
        }
        //console.log(moment(selectedDate).format("YYYY-MM-DD") + " - inside calculatemonth")
        const start = window.dateHandler.getStartOfMonth(selectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(selectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.type === "Stack"));
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        console.log("stack hours:", totalHours);
        return totalHours;
    }
    //previous = number of months to go back
    calculateMonthBillableUser(userId) {
        const selectedDate = store.getters.getSelectedDate;
        const start = window.dateHandler.getStartOfMonth(selectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(selectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.billable === true && report.userId === userId));
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        return totalHours;
    }
    //previous = number of months to go back
    calculateMonthStackUser(userId) {
        const selectedDate = store.getters.getSelectedDate;
        const start = window.dateHandler.getStartOfMonth(selectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(selectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.type === "Stack" && report.userId === userId));
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        return totalHours;
    }
    calculateMonthBillableCustomer(customerName) {
        const selectedDate = store.getters.getSelectedDate;
        const start = window.dateHandler.getStartOfMonth(selectedDate).format("YYYY-MM-DD");
        const end = window.dateHandler.getEndOfMonth(selectedDate).format("YYYY-MM-DD");
        const filtered = this.reports.filter((report) => {
            return ((moment(report.date).format("YYYY-MM-DD") >= start) && (end >= moment(report.date).format("YYYY-MM-DD") && report.billable === true && report.customerName === customerName));
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        return totalHours;
    }
    addReport(report) {
        this.reports.push(report);
    }
    removeReport(reportId) {
        for (let i = 0; i < this.reports.length; i++) {
            const report = this.reports[i];
            if (report.id === reportId) {
                this.reports.splice(i, 1);
                break;
            }
        }
    }
    //returns the total hours you can work in a month, removing holidays etc.
    calculateAvailableHours(holidays, date) {
        const start = window.dateHandler.getStartOfMonth(date || store.getters.getSelectedDate).format("YYYY-MM-DD");
        let totalHours = 0;
        for (let i = 0; i < moment(start).daysInMonth(); i++) {
            const date = window.dateHandler.addDays(start, i);
            if (this.isNonWorkingDay(date, holidays) === false) {
                totalHours += 8;
            }
        }
        return totalHours;
    }
    updateReport(updatedReport) {
        this.removeReport(updatedReport.id);
        this.addReport(updatedReport);
    }
    getMonthWeeks(date) {
        if (date === undefined) {
            date = store.getters.getSelectedDate;
        }
        const weeks = [];
        const startOfMonth = window.dateHandler.getStartOfMonth(date);
        let dates = [];
        let startDate = window.dateHandler.getMondayFromDate(startOfMonth);
        const numberOfWeeks = window.dateHandler.daysInMonth(startOfMonth) / 7;
        for (let j = 0; j < numberOfWeeks; j++) {
            for (let i = 0; i < 7; i++) {
                const currentDate = window.dateHandler.addDays(startDate, i);
                if (window.dateHandler.areDatesInSameMonth(date, currentDate)) {
                    dates.push({ date: currentDate, reports: this.getReportsForDate(currentDate) });
                }
                else {
                    dates.push({ date: null, reports: [] });
                }
            }
            weeks.push(dates);
            dates = [];
            startDate = window.dateHandler.addWeeks(startDate, 1);
        }
        return weeks;
    }
    isNonWorkingDay(date, holidayColl) {
        let holiday;
        if (holidayColl !== undefined && holidayColl !== null) {
            holiday = holidayColl.getHolidayForDate(date);
        }
        if (holiday !== undefined) {
            return true;
        }
        else if (moment(date).isoWeekday() === 6 || moment(date).isoWeekday() === 7) {
            return true;
        }
        else {
            return false;
        }
    }
}
export default ReportCollection;
